import api from "./api/api";

const trackCrud = async ({ action, model_name, item_id, data, changes }) => {
  if (!changes || Object.keys(changes).length === 0) {
    changes = {};
  }

  const payload = {
    action,
    model_name,
    item_id: String(item_id || ''),
    user_agent: navigator.userAgent,
    url: window.location.href,
    data,
    changes,
  };

  const trackingUrl = process.env.REACT_APP_TRACKING_CRUD_URL;
  
  try {
    const response = await fetch(trackingUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
    
    if (!response.ok) {
      console.warn(`CRUD tracking server responded with status: ${response.status}`);
    }
  } catch (err) {
    console.warn("CRUD tracking server unavailable:", err.message);
    
  }
};

const getRequestData = (config) => {
  try {
    if (typeof config.data === "string") {
      return JSON.parse(config.data);
    }
    return config.data;
  } catch (e) {
    return {};
  }
};

const originalDataStore = new Map();

api.interceptors.request.use(
  async (config) => {
    const method = config.method ? config.method.toUpperCase() : null;
    
    if ((method === 'PUT' || method === 'PATCH') && config.url) {
      const url = config.url;

      if (
        url.includes("/track-crud") ||
        url.includes("login") ||
        url.includes("signin") ||
        url.includes("auth")
      ) {
        return config;
      }

      try {
        const parts = url.split("/").filter(Boolean);
        const item_id = parts[parts.length - 1];

        if (item_id && !isNaN(item_id)) {
          const currentDataResponse = await api.get(url);
          originalDataStore.set(`${url}_${item_id}`, currentDataResponse.data);
        }
      } catch (error) {
        console.warn("Could not fetch original data for change tracking:", error.message);
      }
    }
    
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  async (response) => {
    try {
      const config = response.config;
      const method = config.method ? config.method.toUpperCase() : null;

      const crudMap = {
        POST: "create",
        PUT: "update",
        PATCH: "update",
        DELETE: "delete",
      };

      const action = crudMap[method];
      if (!action) return response;

      const url = config.url;
      if (
        url.includes("/track-crud") ||
        url.includes("login") ||
        url.includes("signin") ||
        url.includes("auth")
      ) {
        return response;
      }

      const parts = url.split("/").filter(Boolean);
      const model_name = parts.includes("api") ? parts[parts.indexOf("api") + 1] : parts[0];
      const item_id = parts[parts.length - 1];

      const requestData = getRequestData(config);
      const responseData = response.data;

      let changes = {};

      if (action === "update" && requestData) {
        const storeKey = `${url}_${item_id}`;
        const originalData = originalDataStore.get(storeKey);
        
        if (originalData && typeof originalData === "object") {
          for (const key in requestData) {
            const newVal = requestData[key];
            const oldVal = originalData[key];          
            const valChanged = (newVal !== oldVal) && 
                             !(Number.isNaN(newVal) && Number.isNaN(oldVal)) &&
                             !(newVal === null && oldVal === undefined) &&
                             !(newVal === undefined && oldVal === null);
            
            if (valChanged) {
              changes[key] = {
                from: oldVal !== undefined ? oldVal : null,
                to: newVal !== undefined ? newVal : null,
              };
            }
          }
          
          originalDataStore.delete(storeKey);
        } else {
          console.warn("No original data found for change tracking, using request data only");
          for (const key in requestData) {
            changes[key] = {
              from: "unknown",
              to: requestData[key]
            };
          }
        }
      }

      trackCrud({
        action,
        model_name,
        item_id,
        data: requestData,
        changes,
      }).catch(error => {
        console.warn("Failed to track CRUD action:", error.message);
      });

    } catch (error) {
      console.warn("Error in CRUD tracking interceptor:", error.message);
    }

    return response;
  },
  (error) => Promise.reject(error)
);

export default trackCrud;